import React from "react";
import { fileUrl } from "@/lib/api";
import { X } from "lucide-react";

export default function ReceiptViewer({ path, onClose }) {
  const url = fileUrl(path);
  const isPdf = (path || "").toLowerCase().includes(".pdf");
  return (
    <div
      className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="receipt-viewer-overlay"
    >
      <button
        className="absolute top-4 end-4 h-12 w-12 rounded-full bg-white/15 text-white flex items-center justify-center backdrop-blur"
        onClick={onClose}
        data-testid="receipt-close-btn"
      >
        <X className="h-6 w-6" />
      </button>
      {isPdf ? (
        <iframe src={url} title="receipt" className="w-full h-full max-w-3xl rounded-xl bg-white" />
      ) : (
        <img
          src={url}
          alt="justificatif"
          className="max-h-[90vh] max-w-full rounded-xl object-contain"
          onClick={(e) => e.stopPropagation()}
        />
      )}
    </div>
  );
}
